module.exports = __webpack_public_path__ + "static/img/OSCAR_Class_white.2b25aa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/OSCAR_Class_white.png
// module id = Xltb
// module chunks = 3